import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { getRates } from '../../../api/rates';

const useRates = (
  options?: Omit<UseQueryOptions, 'queryKey' | 'queryFn'>,
  systemId?: string
) => {
  return useQuery({
    queryKey: ['rates', systemId],
    queryFn: () => getRates(systemId),
    ...options,
  });
};

export default useRates;
